<template>
  <div class="city-code">

    <div v-for="(item, key) in cityCodeComponents" :key="key">
      <component :is="item.cName" v-if="item.rName === $route.name"></component>
    </div>

  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
export default {
  data() {
    return {
      cityCodeComponents: [
        {
          rName: 'smallcity',
          cName: defineAsyncComponent(() => import('@/components/citycode/small'))
        },
        {
          rName: 'longcity',
          cName: defineAsyncComponent(() => import('@/components/citycode/long'))
        },
      ],
    }
  },
}
</script>

<style scoped>

</style>